
import { useState, useEffect, useRef } from "react";
import Modal from "react-modal";
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faSquareCaretLeft } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { usePatologia } from "../../context/PatologiaContext";
import { useZona } from "../../context/ZonaContext";
import EventTagInput from "../common/EventTagInput";
import { calcularSemanaEpidemiologica } from "../../common/epidemiologia";

import React from "react";
const AddPersona = () => {
    // Localidad/Dirección
    const [direccion, setDireccion] = useState("");
    const [coordenadas, setCoordenadas] = useState(null); // {lat, lng}
    const [ubicacionGeoLoc, setUbicacionGeoLoc] = useState(null);
    const [modalMapaAbierto, setModalMapaAbierto] = useState(false);
    const [zonaGeografica, setZonaGeografica] = useState(null); // IdZonaGeografica

  // Abrir/cerrar modal
  const handleAbrirMapa = () => setModalMapaAbierto(true);
  const handleCerrarMapa = () => setModalMapaAbierto(false);

  // Leaflet marker icon fix (default icon bug)
  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  });

  // Autocompletado de direcciones (Nominatim)
  const [sugerenciasDireccion, setSugerenciasDireccion] = useState([]);
  const [buscandoDireccion, setBuscandoDireccion] = useState(false);
  const timeoutDireccion = useRef(null);

  // Buscar sugerencias de dirección
  const buscarDireccion = (query) => {
    if (timeoutDireccion.current) clearTimeout(timeoutDireccion.current);
    if (!query || query.length < 3) {
      setSugerenciasDireccion([]);
      return;
    }
    setBuscandoDireccion(true);
    timeoutDireccion.current = setTimeout(async () => {
      try {
        const resp = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&addressdetails=1&limit=5`);
        const data = await resp.json();
        setSugerenciasDireccion(data);
      } catch (e) {
        setSugerenciasDireccion([]);
      } finally {
        setBuscandoDireccion(false);
      }
    }, 400);
  };

  const obtenerDireccionPorCoordenadas = async ({ lat, lng }) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json&addressdetails=1`
      );
      return await response.json();
    } catch {
      return null;
    }
  };

  const getAddressValue = (address, keys) => {
    if (!address) return null;
    for (const key of keys) {
      if (address[key]) return address[key];
    }
    return null;
  };

  const buildDomicilioGeoData = (geoLoc) => {
    const address = geoLoc?.address || {};
    return {
      Barrio: getAddressValue(address, ["neighbourhood", "suburb", "city_district", "quarter", "district"]),
      Localidad: getAddressValue(address, ["city", "town", "village", "municipality", "locality", "county"]),
      Provincia: getAddressValue(address, ["state", "province", "region", "state_district"]),
      Pais: getAddressValue(address, ["country"]),
    };
  };

  const extraerNumeroDomicilio = (geoLoc, direccionTexto) => {
    const address = geoLoc?.address || {};
    const numeroGeoLoc = getAddressValue(address, ["house_number"]);
    if (numeroGeoLoc) return numeroGeoLoc;

    const texto = (direccionTexto || "").trim();
    const numeroTexto = texto.match(/\b\d{1,6}[A-Za-z]?\b/);
    return numeroTexto?.[0] || "S/N";
  };

  // Componente para seleccionar punto en el mapa
  function LocationMarker() {
    const map = useMap();
    useMapEvents({
      async click(e) {
        setCoordenadas(e.latlng);
        const ubicacionEncontrada = await obtenerDireccionPorCoordenadas(e.latlng);
        setUbicacionGeoLoc(ubicacionEncontrada);
        setDireccion(ubicacionEncontrada?.display_name || "Ubicacion seleccionada en mapa");
      },
    });
    // Centrar el mapa cuando cambian las coordenadas
    React.useEffect(() => {
      if (coordenadas && map) {
        map.setView(coordenadas, map.getZoom());
      }
    }, [map]);
    return coordenadas ? <Marker position={coordenadas} /> : null;
  }

  // Confirmar selección y cerrar modal
  const handleSeleccionarDireccion = () => {
    setModalMapaAbierto(false);
  };
  // Estados principales
  const [tiposDocumentoPorPais, setTiposDocumentoPorPais] = useState([]);
  const [Email, setEmail] = useState("");
  const [Telefono, setTelefono] = useState("");
  const [Observaciones, setObservaciones] = useState("");
  const [Eventos, setEventos] = useState("");
  const [mostrarEventosCampo, setMostrarEventosCampo] = useState(false);
  const [Nombre, setNombre] = useState("");
  const [Apellido, setApellido] = useState("");
  const [FechaNacimiento, setFechaNacimiento] = useState("");
  const [Edad, setEdad] = useState(0);
  const [IdGrupoEtario, setIdGrupoEtario] = useState("");
  const [IdEstablecimientoDiagnostico, setIdEstablecimientoDiagnostico] = useState("");
  const [establecimientosDiagnostico, setEstablecimientosDiagnostico] = useState([]);
  const [IdSector, setIdSector] = useState("");
  const [IdSubsector, setIdSubsector] = useState("");
  const [sectores, setSectores] = useState([]);
  const [subsectores, setSubsectores] = useState([]);
  const [IdAreaZona, setIdAreaZona] = useState("");
  const [IdAreaProgramatica, setIdAreaProgramatica] = useState("");
  const [areasZonas, setAreasZonas] = useState([]);
  const [areasProgramaticas, setAreasProgramaticas] = useState([]);
  const [IdInstitucionSeguimientoTratamiento, setIdInstitucionSeguimientoTratamiento] = useState("");
  const [institucionesSeguimientoTratamiento, setInstitucionesSeguimientoTratamiento] = useState([]);
  const [IdEvolucionClinicoTerapeutica, setIdEvolucionClinicoTerapeutica] = useState("");
  const [evolucionesClinicoTerapeuticas, setEvolucionesClinicoTerapeuticas] = useState([]);
  const [gruposEtarios, setGruposEtarios] = useState([]);
  const [Sexo, setSexo] = useState("");
  const [Genero, setGenero] = useState("");
  const [IdTipoDocumento, setIdTipoDocumento] = useState("");
  const [IdPais, setIdPais] = useState(0);
  const [nombrePais, setNombrePais] = useState([]);
  const [NroDocumento, setNroDocumento] = useState("");
  const [patologiaUsuario, setPatologiaUsuario] = useState(null);
  const [zonaSanitariaUsuario, setZonaSanitariaUsuario] = useState(null);
  const [zonasAsignadas, setZonasAsignadas] = useState([]);
  // Eliminado: patologia, patologiaNombre (no usados)
  const [tiposDePatologia, setTiposDePatologia] = useState([]);
const [persona, setPersona] = useState(null);
  const { patologiaActiva } = usePatologia();
  const { zonaActiva } = useZona();

  const [fechaSintomas, setFechaSintomas] = useState("");
  const [desconoceFechaSintomas, setDesconoceFechaSintomas] = useState(false);
  const [fechaExposicion, setFechaExposicion] = useState("");
  const [desconoceFechaExposicion, setDesconoceFechaExposicion] = useState(false);
  const [fechaConsulta, setFechaConsulta] = useState("");
  const [FechaApertura, setFechaApertura] = useState("");
  const [desconoceFechaApertura, setDesconoceFechaApertura] = useState(false);
  const [FechaNotificacion, setFechaNotificacion] = useState("");
  const [desconoceFechaNotificacion, setDesconoceFechaNotificacion] = useState(false);
  const [SemanaEpidemiologica, setSemanaEpidemiologica] = useState("");
  const [ClasificacionInicioTratamiento, setClasificacionInicioTratamiento] = useState("");
  const [FechaInicioTratamiento, setFechaInicioTratamiento] = useState("");
  const [desconoceFechaInicioTratamiento, setDesconoceFechaInicioTratamiento] = useState(false);
  const [FechaFinTratamiento, setFechaFinTratamiento] = useState("");
  const [desconoceFechaFinTratamiento, setDesconoceFechaFinTratamiento] = useState(false);
  const [ResultadoTratamiento, setResultadoTratamiento] = useState("");
  const [estadosTratamiento, setEstadosTratamiento] = useState([]);
  const [desconoceFechaConsulta, setDesconoceFechaConsulta] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [errorFechaExposicion, setErrorFechaExposicion] = useState("");
  const [errorFechaSintomas, setErrorFechaSintomas] = useState("");
  const [errorFechaConsulta, setErrorFechaConsulta] = useState("");
  const [bloquear, setBloquear] = useState(false);
  const nroDocumentoRef = useRef(null);
  const idUsuario = localStorage.getItem("idUsuario");
  const fechaActual = new Date().toISOString().split("T")[0];
  const [comorbilidadesDisponibles, setComorbilidadesDisponibles] = useState([]);
  const [comorbilidadesSeleccionadas, setComorbilidadesSeleccionadas] = useState([]);
  const [diagnosticosDisponibles, setDiagnosticosDisponibles] = useState([]);
  const [diagnosticosSeleccionados, setDiagnosticosSeleccionados] = useState([]);
  
  // Estados para autocompletar búsqueda (eliminados los no usados)
  const timeoutBusqueda = useRef(null);
      
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/grupos-etarios")
      .then(({ data }) => setGruposEtarios(data.filter((grupo) => Number(grupo.Estado) === 1)))
      .catch((error) => console.error("Error al obtener grupos etarios:", error));
  }, []);

  useEffect(() => {
    api.get("/establecimientos-diagnostico")
      .then(({ data }) => setEstablecimientosDiagnostico(data.filter((item) => Number(item.Estado) === 1)))
      .catch((error) => console.error("Error al obtener establecimientos de diagnóstico:", error));
  }, []);

  useEffect(() => {
    Promise.all([api.get("/sectores"), api.get("/subsectores")])
      .then(([respuestaSectores, respuestaSubsectores]) => {
        setSectores(respuestaSectores.data.filter((item) => Number(item.Estado) === 1));
        setSubsectores(respuestaSubsectores.data.filter((item) => Number(item.Estado) === 1 && Number(item.EstadoSector) === 1));
      })
      .catch((error) => console.error("Error al obtener sectores y subsectores:", error));
  }, []);

  useEffect(() => {
    Promise.all([api.get("/areas-zonas"), api.get("/areas-programaticas")])
      .then(([zonas, areas]) => {
        setAreasZonas(zonas.data.filter((item) => Number(item.Estado) === 1));
        setAreasProgramaticas(areas.data.filter((item) => Number(item.Estado) === 1 && Number(item.EstadoAreaZona) === 1));
      })
      .catch((error) => console.error("Error al obtener zonas y áreas programáticas:", error));
  }, []);

  useEffect(() => {
    Promise.all([api.get("/instituciones-seguimiento-tratamiento"), api.get("/evoluciones-clinico-terapeuticas")])
      .then(([instituciones, evoluciones]) => {
        setInstitucionesSeguimientoTratamiento(instituciones.data.filter((item) => Number(item.Estado) === 1));
        setEvolucionesClinicoTerapeuticas(evoluciones.data.filter((item) => Number(item.Estado) === 1));
      })
      .catch((error) => console.error("Error al obtener catálogos de tratamiento:", error));
  }, []);

  useEffect(() => {
    const edadNumerica = Number(Edad);
    const sugerido = gruposEtarios.find(
      (grupo) => edadNumerica >= Number(grupo.EdadDesde) && edadNumerica <= Number(grupo.EdadHasta)
    );
    setIdGrupoEtario(sugerido ? String(sugerido.IdGrupoEtario) : "");
  }, [Edad, gruposEtarios]);

  useEffect(() => {
    const idPatologia = patologiaUsuario?.idPatologia || patologiaUsuario?.IdPatologia;
    if (!idPatologia) return setEstadosTratamiento([]);
    api.get(`/estados-tratamiento-por-patologia/${idPatologia}`)
      .then(({ data }) => setEstadosTratamiento(data.filter((item) => Number(item.estado) === 1 && Number(item.EstadoCatalogo) === 1)))
      .catch(() => setEstadosTratamiento([]));
  }, [patologiaUsuario]);

  const actualizarFechaNacimiento = (fecha) => {
    setFechaNacimiento(fecha);
    if (!fecha) return;

    const nacimiento = new Date(`${fecha}T00:00:00`);
    const hoy = new Date();
    let edad = hoy.getFullYear() - nacimiento.getFullYear();
    const aunNoCumplio = hoy.getMonth() < nacimiento.getMonth()
      || (hoy.getMonth() === nacimiento.getMonth() && hoy.getDate() < nacimiento.getDate());
    if (aunNoCumplio) edad -= 1;
    if (edad >= 0 && edad <= 120) setEdad(String(edad));
  };

  // Funciones de validación de fechas
  const validarFechaExposicion = (e) => {
    const fecha = e.target.value;
    if (fecha > fechaActual) {
      setErrorFechaExposicion("La fecha no puede ser posterior al día de hoy");
    } else if (fechaSintomas && new Date(fecha) > new Date(fechaSintomas)) {
      setErrorFechaExposicion("La fecha de exposición debe ser anterior a la de síntomas");
      Swal.fire({
        icon: "warning",
        title: "Fecha inválida",
        text: "La fecha de exposición debe ser anterior a la fecha de inicio de síntomas",
      });
    } else {
      setErrorFechaExposicion("");
      setFechaExposicion(fecha);
    }
  };

  const validarFechaSintomas = (e) => {
    const fecha = e.target.value;
    if (fecha > fechaActual) {
      setErrorFechaSintomas("La fecha no puede ser posterior al día de hoy");
    } else if (fechaExposicion && new Date(fechaExposicion) > new Date(fecha)) {
      setErrorFechaSintomas("La fecha de exposición debe ser anterior a la de síntomas");
      Swal.fire({
        icon: "warning",
        title: "Fecha inválida",
        text: "La fecha de exposición debe ser anterior a la fecha de inicio de síntomas",
      });
    } else {
      setErrorFechaSintomas("");
      setFechaSintomas(fecha);
    }
  };

  

  const validarFechaConsulta = (e) => {
    const fecha = e.target.value;
    if (fecha > fechaActual) {
      setErrorFechaConsulta("La fecha no puede ser posterior al día de hoy");
    } else {
      setErrorFechaConsulta("");
      setFechaConsulta(fecha);
    }
  };

  // Funciones de backend
  const getTiposDocumentoActivosPorPais = async (idPais) => {
    try {
      const paisId = Number(idPais);
      const response = await api.get(`/tipodocumentos`);
      const activos = response.data.filter(doc => Number(doc.estado) === 1 && Number(doc.IdPais) === paisId);
      const sugerido = activos.find(doc => String(doc.TipoDocumento).toLowerCase() === "dni") || activos[0];

      setTiposDocumentoPorPais(activos);
      setIdTipoDocumento(sugerido ? String(sugerido.idTipoDocumento) : "");
    } catch (error) {
      console.error("Error al obtener tipos de documento:", error);
      setTiposDocumentoPorPais([]);
      setIdTipoDocumento("");
    }
  };

  const getPaises = async () => {
    try {
      const response = await api.get(`/paises`);
      const paisesActivos = response.data.filter(pais => pais.estado === 1);
      setNombrePais(paisesActivos);
      const argentina = paisesActivos.find(p => p.Nombre === "Argentina");
      if (argentina && !IdPais) {
        setIdPais(argentina.IdPais);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const leerPersonas = async () => {
    await api.get(`/leerPersonas`);
    // Eliminado: setPersonas y response (ya no existen)
  };

 

const searcherDocumento = (e) => {
  const valor = e.target.value.replace(/[^0-9]/g, ""); // solo números
  setNroDocumento(valor);
  // Eliminado: setTerminoBusqueda (ya no existe)

  if (valor.length >= 7) { // ejecutar búsqueda cuando tenga mínimo 7 dígitos
    BuscarNroDocumentoExistente(valor);
  } else {
    setMensaje("");
    setBloquear(false);
    setPersona(null);
  }

  // Buscar sugerencias con debounce
  if (valor.length >= 2) {
    buscarSugerencias(valor);
  } else {
    // Eliminado: setSugerencias, setMostrarSugerencias (ya no existen)
  }
};

// Función para buscar sugerencias con debounce
const buscarSugerencias = (termino) => {
  if (timeoutBusqueda.current) {
    clearTimeout(timeoutBusqueda.current);
  }

  timeoutBusqueda.current = setTimeout(async () => {
    try {
      console.log("🔍 Buscando sugerencias para:", termino);
      const response = await api.get(`/buscarPersonas?termino=${encodeURIComponent(termino)}`);
      
      if (response.data.success && response.data.resultados) {
        // Eliminado: setSugerencias, setMostrarSugerencias (ya no existen)
        console.log("✅ Sugerencias encontradas:", response.data.resultados.length);
      }
    } catch (error) {
      console.error("❌ Error al buscar sugerencias:", error);
      // Eliminado: setSugerencias, setMostrarSugerencias (ya no existen)
    }
  }, 300); // 300ms de debounce
};

// Función para seleccionar una sugerencia
// Eliminado: seleccionarSugerencia (no usado)

const BuscarNroDocumentoExistente = async (dni) => {
  if (!dni) return;

  // 🟢 Validar longitud antes de buscar
  if (dni.length > 8) {
    setMensaje("El DNI supera el límite de 8 números.");
    setBloquear(false);
    return;
  }

  try {
    const response = await api.get(`/buscarNroDocumentoExistente/${dni}`);

    const data = response.data;

    if (data.existe) {
      setPersona(data.persona);

      if (data.tieneClasificaciones && data.clasificaciones.length > 0) {
        // Buscar si ya existe con la misma patología y zona
        const coincidencia = data.clasificaciones.find(
          (c) =>
            c.Patologia === patologiaUsuario?.Nombre &&
            c.ZonaSanitaria === zonaSanitariaUsuario?.Nombre
        );

        if (coincidencia) {
          // 🔴 Misma patología y zona → bloquear
          setBloquear(true);
          setMensaje(
            `Atención:\nYa está registrada con la patología "${coincidencia.Patologia}" en la zona "${coincidencia.ZonaSanitaria}".\nNo se puede volver a registrar.`
          );
          return; // 🔹 Salir aquí para no seguir evaluando
        }

        // 🟢 Otras combinaciones → permitir, pero informar
        const primera = data.clasificaciones[0];
        setBloquear(false);
        setMensaje(
          `La persona ya tiene registros previos, por ejemplo en "${primera.Patologia}" (${primera.ZonaSanitaria}).\nPuede crear un nuevo registro con otra patología o zona.`
        );
      } else {
        // 🟡 Sin clasificaciones previas
        setBloquear(false);
        setMensaje("");
      }
    } else {
      // 🟡 DNI no registrado
      setPersona(null);
      setBloquear(false);
      setMensaje("DNI no registrado aún.");
    }
  } catch (error) {
    console.error("Error al buscar DNI:", error);
    setMensaje("");
    setBloquear(false);
  }
};

// Eliminado: obtenerIdEstadoPorNombreOSistema (no usado)

  const crearSeguimientoAutomatico = async (idPersona) => {
    const idUsuarioLocal = idUsuario || localStorage.getItem("idUsuario");

    const datosSeguimiento = {
      idPersona: Number(idPersona),
      idPatologia: patologiaUsuario?.idPatologia ? Number(patologiaUsuario.idPatologia) : null,
      idZonaSanitaria: zonaSanitariaUsuario?.IdZonaSanitaria ? Number(zonaSanitariaUsuario.IdZonaSanitaria) : null,
      idUsuario: idUsuarioLocal ? Number(idUsuarioLocal) : null,
      fechaInicio: new Date().toISOString().slice(0, 19).replace("T", " "),
      observaciones: "Seguimiento creado automáticamente al registrar caso"
    };

    await api.post(`/seguimientos`, datosSeguimiento, {
      headers: { "Content-Type": "application/json" }
    });
  };


  const createPersona = async () => {
    if (!IdPais) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Seleccioná la Nacionalidad" });
    if (!IdTipoDocumento) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Seleccioná el Tipo de Documento" });
    if (!NroDocumento) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Ingresá el Número de Documento" });
    if (!Nombre) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Ingresá el Nombre" });
    if (!Apellido) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Ingresá el Apellido" });
    if (!Edad || Edad <= 0) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Ingresá una Edad válida" });
    if (!Sexo) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Seleccioná el Sexo" });
    if (!Genero) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Seleccioná el género" });
    if (!Telefono) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Ingresá el teléfono" });
    if (!IdEstablecimientoDiagnostico) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Seleccioná el establecimiento de diagnóstico" });
    if (!IdSector) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Seleccioná el sector" });
    if (!IdAreaZona) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Seleccioná la zona" });
    if (!IdInstitucionSeguimientoTratamiento) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Seleccioná la institución de seguimiento del tratamiento" });
    if (!IdEvolucionClinicoTerapeutica) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Seleccioná la evolución clínico-terapéutica" });
    if (!patologiaUsuario) return Swal.fire({ icon: "warning", title: "Falta completar", text: "No se pudo determinar la patología del usuario" });
    if (!desconoceFechaExposicion && !fechaExposicion) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Ingresá la fecha de exposición o marcá 'Se desconoce'" });
    if (!desconoceFechaSintomas && !fechaSintomas) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Ingresá la fecha de síntomas o marcá 'Se desconoce'" });
    if (!desconoceFechaConsulta && !fechaConsulta) return Swal.fire({ icon: "warning", title: "Falta completar", text: "Ingresá la fecha de consulta o marcá 'Se desconoce'" });
    if (FechaInicioTratamiento && FechaFinTratamiento && FechaFinTratamiento < FechaInicioTratamiento) return Swal.fire({ icon: "warning", title: "Fechas inválidas", text: "La fecha de fin del tratamiento no puede ser anterior a la fecha de inicio" });

    try {
      // 1. Crear persona
      await api.post(`/createPersona`, {
        IdPais,
        Email,
        Telefono,
        Observaciones,
        Eventos,
        Nombre,
        Apellido,
        IdTipoDocumento,
        NroDocumento,
        FechaNacimiento: FechaNacimiento || null,
        Edad,
        IdGrupoEtario: IdGrupoEtario || null,
        IdEstablecimientoDiagnostico,
        IdSector,
        IdSubsector,
        IdAreaZona,
        IdAreaProgramatica,
        FechaApertura: desconoceFechaApertura ? null : FechaApertura || null,
        FechaNotificacion: desconoceFechaNotificacion ? null : FechaNotificacion || null,
        SemanaEpidemiologica: SemanaEpidemiologica || null,
        ClasificacionInicioTratamiento: ClasificacionInicioTratamiento.trim().toUpperCase() || null,
        FechaInicioTratamiento: desconoceFechaInicioTratamiento ? null : FechaInicioTratamiento || null,
        FechaFinTratamiento: desconoceFechaFinTratamiento ? null : FechaFinTratamiento || null,
        ResultadoTratamiento: ResultadoTratamiento.trim().toUpperCase() || null,
        IdInstitucionSeguimientoTratamiento,
        IdEvolucionClinicoTerapeutica,
        Sexo,
        Genero,
      });

      setEmail(""); setTelefono(""); setObservaciones(""); setEventos(""); setNombre(""); setApellido(""); setNroDocumento(""); setFechaNacimiento(""); setEdad(""); setIdGrupoEtario(""); setIdEstablecimientoDiagnostico(""); setIdSector(""); setIdSubsector(""); setIdAreaZona(""); setIdAreaProgramatica(""); setIdInstitucionSeguimientoTratamiento(""); setIdEvolucionClinicoTerapeutica(""); setFechaApertura(""); setFechaNotificacion(""); setSemanaEpidemiologica(""); setClasificacionInicioTratamiento(""); setFechaInicioTratamiento(""); setFechaFinTratamiento(""); setResultadoTratamiento(""); setSexo(""); setGenero("");
      setDesconoceFechaApertura(false); setDesconoceFechaNotificacion(false); setDesconoceFechaInicioTratamiento(false); setDesconoceFechaFinTratamiento(false);

      // 2. Obtener IdPersona
      const y = await api.get(`/getPersonaByDocument`, {
        params: { Nmbr: NroDocumento, IdTipoDocumento },
      });
      const yy = y.data.IdPersona;

      // 3. Guardar domicilio si hay dirección o coordenadas (la zona tiene fallback en backend)
      if (direccion || coordenadas) {
        const direccionNormalizada =
          (direccion && direccion.trim()) ||
          `Lat: ${coordenadas?.lat?.toFixed?.(5) ?? ""}, Lng: ${coordenadas?.lng?.toFixed?.(5) ?? ""}`;

        const domicilioGeoData = buildDomicilioGeoData(ubicacionGeoLoc);
        const numeroDomicilio = extraerNumeroDomicilio(ubicacionGeoLoc, direccionNormalizada);
        const domicilioPayload = {
          idPersona: yy,
          arrayDomicilios: [
            {
              Calle: direccionNormalizada,
              Numero: numeroDomicilio,
              Piso: null,
              Departamento: null,
              Barrio: domicilioGeoData.Barrio,
              Latitud: coordenadas?.lat ?? null,
              Longitud: coordenadas?.lng ?? null,
              DireccionCompleta: ubicacionGeoLoc?.display_name || direccionNormalizada,
              JsonGeoLoc: ubicacionGeoLoc,
              Localidad: domicilioGeoData.Localidad,
              Provincia: domicilioGeoData.Provincia,
              Pais: domicilioGeoData.Pais,
            },
          ],
          cantidadDomicilios: 1,
          IdZonaGeografica: zonaGeografica || null,
        };
        console.log("Payload domicilio:", domicilioPayload);
        await api.post(`/guardarDomiciliosPorPersonaGis`, domicilioPayload);
      }

      // 4. Estado SISA
      let idEstadoSISA = null;
      try {
        const r = await api.get(`/estados`);
        const estados = r.data;
        if (Array.isArray(estados)) {
          const estadoSISA = estados.find(
            e => e.Nombre?.toUpperCase().trim() === "SISA"
          );
          if (!estadoSISA) {
            const estadoSistema = estados.find(e => Number(e.DeSistema) === 1);
            idEstadoSISA = estadoSistema ? Number(estadoSistema.IdEstado) : null;
          } else {
            idEstadoSISA = Number(estadoSISA.IdEstado);
          }
        }
      } catch (e) {
        console.error("❌ No se pudieron obtener estados:", e);
      }

      await api.post(`/ClasificarContacto`, {
        IdPersona: yy,
        IdPatologia: patologiaUsuario.idPatologia,
        IdClasificacionPersona: 1,
        IdZonaSanitaria: zonaSanitariaUsuario ? zonaSanitariaUsuario.IdZonaSanitaria : null,
      });

      if (idEstadoSISA) {
        try {
          await api.put(`/personas/${yy}/estado`, {
            IdEstado: idEstadoSISA
          }, {
            headers: { "Content-Type": "application/json" }
          });
          console.log("✅ Estado SISA asignado correctamente");
        } catch (errorEstado) {
          console.error("❌ Error al asignar estado SISA:", errorEstado);
        }
      }

      await api.post(`/guardarFechasSeguimiento`, {
        IdPersona: yy,
        fechaSintomas: desconoceFechaSintomas ? null : fechaSintomas,
        fechaExposicion: desconoceFechaExposicion ? null : fechaExposicion,
        fechaConsulta: desconoceFechaConsulta ? null : fechaConsulta,
      });

      if (comorbilidadesSeleccionadas.length > 0) {
        const payloadComorbilidades = {
          IdPersona: yy,
          IdPatologia: patologiaUsuario.idPatologia,
          comorbilidades: comorbilidadesSeleccionadas.map(Number)
        };
        try {
          const respCom = await api.post(`/comorbilidadesxpersonaxpatologia`, payloadComorbilidades);
          console.log('✅ Respuesta comorbilidades:', respCom.data);
        } catch (errorCom) {
          console.error('❌ Error guardando comorbilidades:', errorCom.response?.data || errorCom.message);
          Swal.fire({
            icon: "warning",
            title: "Advertencia",
            text: "La persona fue creada pero hubo un problema al guardar las comorbilidades.",
            timer: 3000
          });
        }
      }

      if (diagnosticosSeleccionados.length > 0) {
        const payloadDiagnosticos = {
          IdPersona: yy,
          IdPatologia: patologiaUsuario.idPatologia,
          diagnosticos: diagnosticosSeleccionados.map(Number)
        };
        try {
          const respDiag = await api.post(`/diagnosticosxpersonaxpatologia`, payloadDiagnosticos);
          console.log('✅ Respuesta diagnósticos:', respDiag.data);
        } catch (errorDiag) {
          console.error('❌ Error guardando diagnósticos:', errorDiag.response?.data || errorDiag.message);
          Swal.fire({
            icon: "warning",
            title: "Advertencia",
            text: "La persona fue creada pero hubo un problema al guardar los diagnósticos.",
            timer: 3000
          });
        }
      }

      await crearSeguimientoAutomatico(yy);

      setFechaSintomas(""); setDesconoceFechaSintomas(false);
      setFechaExposicion(""); setDesconoceFechaExposicion(false);
      setFechaConsulta(""); setDesconoceFechaConsulta(false);
      setDireccion(""); setCoordenadas(null); setUbicacionGeoLoc(null); setZonaGeografica(null);

      Swal.fire({
        icon: "success",
        title: "Persona guardada",
        text: "La persona fue registrada correctamente.",
        timer: 1800,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: "error", title: "Error inesperado", text: "Ocurrió un error al guardar la persona." });
    }
  };

  

  const handleGoBack = () => navigate(-1);

  // Eliminado: esExtranjero (no usado)

  // useEffect

  // Cuando cambia persona, actualizar los campos del formulario
  useEffect(() => {
    if (persona) {
      setNombre(persona.Nombre || "");
      setApellido(persona.Apellido || "");
      setFechaNacimiento(persona.FechaNacimiento || "");
      setEdad(persona.Edad || 0);
      setSexo(persona.Sexo || "");
      setGenero(persona.Genero || "");
      setEmail(persona.Email || "");
      setObservaciones(persona.Observaciones || "");
      setEventos(persona.Eventos || "");
      setIdTipoDocumento(persona.IdTipoDocumento || "");
      setIdPais(persona.IdPais || 0);
    }
  }, [persona]);

  useEffect(() => {
    if ((Eventos || "").trim()) {
      setMostrarEventosCampo(true);
    }
  }, [Eventos]);
  useEffect(() => {
    if (!idUsuario) return;

    api
      .get(`/usuarios/${idUsuario}`)
      .then(res => {
        const zonasDisponibles = res.data.zonasAsignadas || [];
        setZonasAsignadas(zonasDisponibles);

        const zonaPredeterminada =
          res.data.zonaActiva || zonasDisponibles.find(z => z.EsDefault === 1) || null;

        if (zonaActiva) {
          const zonaSeleccionada = zonasDisponibles.find(z => z.Nombre === zonaActiva);
          if (zonaSeleccionada) {
            setZonaSanitariaUsuario(zonaSeleccionada);
            return;
          }
        }

        setZonaSanitariaUsuario(zonaPredeterminada);
      })
      .catch(err => console.error(err));
  }, [idUsuario, zonaActiva]);

useEffect(() => {
  const getPatologiasUsuario = async () => {
    if (!idUsuario) return;

    try {
      const response = await api.get(`/patologias-usuario/${idUsuario}/activas`);

      console.log("👉 Patologías activas:", response.data);

      if (response.data && response.data.length > 0) {
        setTiposDePatologia(response.data);

        const idPatologiaSeleccionada = localStorage.getItem("idPatologiaSeleccionada");
        let seleccionada = null;

        if (patologiaActiva) {
          seleccionada = response.data.find(p => p.Nombre === patologiaActiva);
        }

        if (!seleccionada && idPatologiaSeleccionada) {
          seleccionada = response.data.find(
            p =>
              p.idPatologia?.toString() === idPatologiaSeleccionada ||
              p.IdPatologia?.toString() === idPatologiaSeleccionada
          );
        }

        if (!seleccionada) {
          seleccionada = response.data[0];
        }

        if (seleccionada) {
          setPatologiaUsuario(seleccionada);
        } else {
          setPatologiaUsuario(null);
        }
      } else {
        setPatologiaUsuario(null);
      }
    } catch (err) {
      console.error("Error al obtener patologías:", err);
      setPatologiaUsuario(null);
    }
  };

  getPatologiasUsuario();
}, [idUsuario, patologiaActiva]);



useEffect(() => {
  const getComorbilidadesPorPatologia = async () => {
    if (!patologiaUsuario || !patologiaUsuario.idPatologia) return;
    try {
      const response = await api.get(`/comorbilidades/${patologiaUsuario.idPatologia}`);
      setComorbilidadesDisponibles(response.data.filter(c => Number(c.estadoRelacion) === 1));
    } catch (error) {
      console.error("Error al obtener comorbilidades:", error);
      setComorbilidadesDisponibles([]);
    }
  };
  getComorbilidadesPorPatologia();
}, [patologiaUsuario]);

useEffect(() => {
  const getDiagnosticosPorPatologia = async () => {
    if (!patologiaUsuario || !patologiaUsuario.idPatologia) return;
    try {
      const response = await api.get(`/diagnosticosPorPatologia/${patologiaUsuario.idPatologia}`);
      const diagnosticosNormalizados = Array.isArray(response.data)
        ? response.data
            .map((d) => ({
              ...d,
              Nombre: d.Nombre || d.NombreDiagnostico || d.diagnostico?.Nombre || "Sin nombre",
            }))
            .filter(d => Number(d.estado) === 1)
        : [];
      setDiagnosticosDisponibles(diagnosticosNormalizados);
    } catch (error) {
      console.error("Error al obtener diagnósticos:", error);
      setDiagnosticosDisponibles([]);
    }
  };
  getDiagnosticosPorPatologia();
}, [patologiaUsuario]);

useEffect(() => {
  if (!patologiaActiva) return;

  if (tiposDePatologia.length > 0) {
    const seleccionada = tiposDePatologia.find(p => p.Nombre === patologiaActiva);
    if (seleccionada) {
      setPatologiaUsuario(seleccionada);
      return;
    }
  }

  const idSeleccionadaLocal = localStorage.getItem("idPatologiaSeleccionada");
  const idNumerico = idSeleccionadaLocal ? parseInt(idSeleccionadaLocal, 10) : NaN;

  if (!Number.isNaN(idNumerico)) {
    setPatologiaUsuario(prev => ({
      ...(prev || {}),
      idPatologia: idNumerico,
      Nombre: patologiaActiva,
    }));
    // Eliminado: setPatologiaNombre (no usado)
  }

  // Eliminado: setPatologiaNombre (no usado)
}, [patologiaActiva, tiposDePatologia]);

useEffect(() => {
  if (!zonaActiva) return;

  if (zonasAsignadas.length > 0) {
    const zonaSeleccionada = zonasAsignadas.find(z => z.Nombre === zonaActiva);
    if (zonaSeleccionada) {
      setZonaSanitariaUsuario(zonaSeleccionada);
      return;
    }
  }

  const idZonaLocal = localStorage.getItem("idZonaActiva");
  const idZonaNumerico = idZonaLocal ? parseInt(idZonaLocal, 10) : NaN;

  if (!Number.isNaN(idZonaNumerico)) {
    setZonaSanitariaUsuario(prev => ({
      ...(prev || {}),
      IdZonaSanitaria: idZonaNumerico,
      Nombre: zonaActiva,
    }));
    return;
  }

  setZonaSanitariaUsuario(prev =>
    prev ? { ...prev, Nombre: zonaActiva } : { Nombre: zonaActiva }
  );
}, [zonaActiva, zonasAsignadas]);


// Eliminado: getZonaUsuario (no usado)










  // Cerrar sugerencias al hacer clic fuera
  useEffect(() => {
    // Eliminado: lógica de setMostrarSugerencias y handleClickOutside (ya no existen)
    return () => {
      if (timeoutBusqueda.current) {
        clearTimeout(timeoutBusqueda.current);
      }
    };
  }, []);

  useEffect(() => { if (nroDocumentoRef.current) nroDocumentoRef.current.focus(); }, []);

  useEffect(() => { leerPersonas(); }, []);

  useEffect(() => { if (NroDocumento.length > 0) BuscarNroDocumentoExistente(NroDocumento); }, [NroDocumento]);


  // Eliminado: lógica de BotonGuardarPersonaActivo y NroDocumentoEncontrado (ya no existen)

  useEffect(() => { if (IdPais) getTiposDocumentoActivosPorPais(IdPais); }, [IdPais]);

  // Eliminado: useEffect de BotonGuardarPersona (ya no existe)

  useEffect(() => { getPaises(); FechaHoy(); }, []);

  const FechaHoy = async () => {
    // Eliminado: hora, minutos, segundos (no usados)
  };

  const nombreCasoEvento = [Nombre, Apellido].filter(Boolean).join(" ").trim();

  return (
  <div className="columns mt-5 is-centered">
    <div className="column is-half">
      <label className="label" style={{ textAlign: "center" }}>
        Cargar casos
      </label>
      <br />
      <label className="label">Agregar persona</label>
      <br />

      {/* GRID DE DOS COLUMNAS */}
      <div
        className="form-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "16px 20px",
        }}
      >
        {/* NACIONALIDAD */}
        <div className="field" style={{ gridColumn: "1 / span 2" }}>
          <label className="label required">Nacionalidad</label>
          <div className="select is-fullwidth">
            <select
              value={IdPais}
              onChange={(e) => setIdPais(e.target.value ? Number(e.target.value) : "")}
              onClick={getPaises}
              required
            >
              <option value="">Seleccionar</option>
              {nombrePais.map((NombrePais) => (
                <option
                  value={NombrePais.IdPais}
                  key={NombrePais.IdPais}
                >
                  {NombrePais.Nombre}
                </option>
              ))}
            </select>
          </div>
        </div>



        {/* TIPO DE DOCUMENTO */}
        {IdPais !== "" && IdPais !== 0 && (
          <div className="field">
            <label className="label required">Tipo de Documento</label>
            <div className="select is-fullwidth">
              <select
                value={IdTipoDocumento}
                onChange={(e) => setIdTipoDocumento(e.target.value)}
                required
              >
                <option value="">Seleccionar</option>
                {tiposDocumentoPorPais.map((tipo) => (
                  <option
                    key={tipo.idTipoDocumento}
                    value={tipo.idTipoDocumento}
                  >
                    {tipo.TipoDocumento}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        {/* PATOLOGÍA ASIGNADA */}
        <div className="field">
          <label className="label">Patología asignada</label>
          <p
            className="text-success mt-1"
            style={{
              fontWeight: "500",
              padding: "0.5rem 0.75rem",
              borderRadius: "6px",
              backgroundColor: "#f0f9ff",
              border: "1px solid #bee3f8",
              color: "#1e40af",
            }}
          >
            {patologiaUsuario
              ? `✅ ${patologiaUsuario.Nombre}`
              : "⚠️ No hay patología asignada"}
          </p>
          <input
            type="hidden"
            value={patologiaUsuario ? patologiaUsuario.idPatologia : ""}
          />
        </div>
{/* NÚMERO DE DOCUMENTO */}
<div className="field documento-field">
  <div className="documento-grid">
    <div className="campo-dni">
      <label className="label required">Número de Documento</label>
      <div className="control">
        <input
          type="text"
          className="input"
          value={NroDocumento}
          onChange={searcherDocumento}
          placeholder="Documento"
          required
          ref={nroDocumentoRef}
        />
      </div>
    </div>

   {/* MENSAJE DE VALIDACIÓN — a la derecha del DNI */}
{mensaje && (
  <div
    className={`mensaje-cuadro ${bloquear ? "bloqueo" : "informativo"}`}
    style={{ whiteSpace: "pre-line" }}
  >
    {mensaje}
  </div>
)}

  </div>
</div>

<style jsx>{`
  .documento-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    align-items: start;
  }

  @media (max-width: 768px) {
    .documento-grid {
      grid-template-columns: 1fr;
    }
  }

  .mensaje-cuadro {
    background: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 12px 14px;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    line-height: 1.4;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  }

  .mensaje-cuadro.bloqueo {
    border: 1px solid #e74c3c;
    background: #fdecea;
    color: #c0392b;
  }

  .mensaje-cuadro.informativo {
    border: 1px solid #27ae60;
    background: #eafaf1;
    color: #14532d;
  }
`}</style>

        {/* ZONA SANITARIA */}
        <div className="field">
          <label className="label">Zona asignada del usuario</label>
          <p
            className="text-success mt-1"
            style={{
              fontWeight: "500",
              padding: "0.5rem 0.75rem",
              borderRadius: "6px",
              backgroundColor: "#f0fdf4",
              border: "1px solid #c6f6d5",
              color: "#065f46",
            }}
          >
            {zonaSanitariaUsuario
              ? `✅ ${zonaSanitariaUsuario.Nombre}`
              : "⚠️ Sin zona asignada"}
          </p>
          <input
            type="hidden"
            value={
              zonaSanitariaUsuario
                ? zonaSanitariaUsuario.IdZonaSanitaria
                : ""
            }
          />
        </div>

        {/* NOMBRE */}
        <div className="field" style={{ gridColumn: "1 / span 2" }}>
          <label className="label required">Nombre</label>
          <div className="control">
            <input
              type="text"
              className="input"
              value={Nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Nombre"
              required
            />
          </div>
        </div>

      </div>



        <div className="event-inline-row">
          <div className="field">
            <label className="label required">Apellido</label>
            <div className="control">
              <input type="text" className="input" value={Apellido} onChange={(e) => setApellido(e.target.value)} placeholder="Apellido" required />
            </div>
          </div>

          <div className="field event-inline-events">
            <div className="event-inline-control-row">
              <button
                type="button"
                className="event-inline-trigger"
                onClick={() => setMostrarEventosCampo((prev) => !prev)}
              >
                Eventos
              </button>

              {mostrarEventosCampo && (
                <div className="event-inline-panel-right">
                  <div className="event-inline-panel-actions">
                    <button
                      type="button"
                      className="event-inline-close"
                      onClick={() => setMostrarEventosCampo(false)}
                    >
                      Ocultar
                    </button>
                  </div>
                  <EventTagInput
                    value={Eventos}
                    onChange={setEventos}
                    caseDisplayName={nombreCasoEvento}
                    placeholder="Agregar evento"
                    compact
                    showHint={false}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="field">
          <label className="label">Fecha de nacimiento</label>
          <div className="control">
            <input type="date" className="input" value={FechaNacimiento} max={fechaActual} onChange={(e) => actualizarFechaNacimiento(e.target.value)} />
          </div>
          <p className="help">Opcional. Al ingresarla se calcula la edad automáticamente.</p>
        </div>

        {/* Edad */}
        <div className="field">
          <label className="label required">Edad</label>
          <div className="control">
            <input type="number" max="120" min="0" pattern="^[1-9]" className="input" value={Edad} onChange={(e) => setEdad(e.target.value)} placeholder="edad" required />
          </div>
        </div>
        <div className="field">
          <label className="label">Grupo etario</label>
          <div className="control">
            <div className="select is-fullwidth">
              <select value={IdGrupoEtario} onChange={(e) => setIdGrupoEtario(e.target.value)}>
                <option value="">Sin asignar</option>
                {gruposEtarios.map((grupo) => (
                  <option key={grupo.IdGrupoEtario} value={grupo.IdGrupoEtario}>
                    {grupo.Nombre} ({grupo.EdadDesde} a {grupo.EdadHasta} años)
                  </option>
                ))}
              </select>
            </div>
          </div>
          <p className="help">Se sugiere automáticamente según la edad y puede modificarse.</p>
        </div>
        <div className="field">
          <label className="label required">Establecimiento de diagnóstico</label>
          <div className="control"><div className="select is-fullwidth">
            <select value={IdEstablecimientoDiagnostico} onChange={(e) => setIdEstablecimientoDiagnostico(e.target.value)} required>
              <option value="">Seleccionar establecimiento</option>
              {establecimientosDiagnostico.map((item) => <option key={item.IdEstablecimientoDiagnostico} value={item.IdEstablecimientoDiagnostico}>{item.Nombre}</option>)}
            </select>
          </div></div>
        </div>
        <div className="field">
          <label className="label required">Sector</label>
          <div className="control"><div className="select is-fullwidth"><select value={IdSector} onChange={(e) => { setIdSector(e.target.value); setIdSubsector(""); }} required>
            <option value="">Seleccionar sector</option>
            {sectores.map((item) => <option key={item.IdSector} value={item.IdSector}>{item.Nombre}</option>)}
          </select></div></div>
        </div>
          <div className="field">
            <label className="label">Subsector</label>
          <div className="control"><div className="select is-fullwidth"><select value={IdSubsector} onChange={(e) => setIdSubsector(e.target.value)} disabled={!IdSector}>
            <option value="">Sin asignar</option>
            {subsectores.filter((item) => Number(item.IdSector) === Number(IdSector)).map((item) => <option key={item.IdSubsector} value={item.IdSubsector}>{item.Nombre}</option>)}
          </select></div></div>
        </div>
        <div className="field">
          <label className="label required">Institución de seguimiento del tratamiento</label>
          <div className="control"><div className="select is-fullwidth"><select value={IdInstitucionSeguimientoTratamiento} onChange={(e) => setIdInstitucionSeguimientoTratamiento(e.target.value)} required>
            <option value="">Seleccionar institución</option>
            {institucionesSeguimientoTratamiento.map((item) => <option key={item.IdInstitucionSeguimientoTratamiento} value={item.IdInstitucionSeguimientoTratamiento}>{item.Nombre}</option>)}
          </select></div></div>
        </div>
        <div className="field">
          <label className="label required">Evolución clínico-terapéutica del tratamiento</label>
          <div className="control"><div className="select is-fullwidth"><select value={IdEvolucionClinicoTerapeutica} onChange={(e) => setIdEvolucionClinicoTerapeutica(e.target.value)} required>
            <option value="">Seleccionar evolución</option>
            {evolucionesClinicoTerapeuticas.map((item) => <option key={item.IdEvolucionClinicoTerapeutica} value={item.IdEvolucionClinicoTerapeutica}>{item.Nombre}</option>)}
          </select></div></div>
        </div>
      {/* COMORBILIDADES */}
      {comorbilidadesDisponibles.length > 0 && (
        <div className="field mt-4">
          <label className="label">
            Comorbilidades (seleccione una o varias)
          </label>
          <div
            className="box"
            style={{
              maxHeight: "200px",
              overflowY: "auto",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              padding: "0.75rem",
              backgroundColor: "#f9fafb",
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "6px 12px",
            }}
          >
            {[...comorbilidadesDisponibles]
              .sort((a, b) => a.Nombre.localeCompare(b.Nombre))
              .map((com) => (
                <label
                  key={com.IdComorbilidad}
                  className="checkbox"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "4px 0",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                  }}
                >
                  <input
                    type="checkbox"
                    value={com.IdComorbilidad}
                    checked={comorbilidadesSeleccionadas.includes(
                      com.IdComorbilidad.toString()
                    )}
                    onChange={(e) => {
                      const id = e.target.value;
                      setComorbilidadesSeleccionadas((prev) =>
                        e.target.checked
                          ? [...prev, id]
                          : prev.filter((c) => c !== id)
                      );
                    }}
                    style={{ marginRight: "8px" }}
                  />
                  {com.Nombre}
                </label>
              ))}
          </div>
          <div className="field">
            <label className="label required">Zona</label>
            <div className="control"><div className="select is-fullwidth"><select value={IdAreaZona} onChange={(e) => { setIdAreaZona(e.target.value); setIdAreaProgramatica(""); }} required>
              <option value="">Seleccionar zona</option>
              {areasZonas.map((item) => <option key={item.IdAreaZona} value={item.IdAreaZona}>{item.Nombre}</option>)}
            </select></div></div>
          </div>
          <div className="field">
            <label className="label">Área programática</label>
            <div className="control"><div className="select is-fullwidth"><select value={IdAreaProgramatica} onChange={(e) => setIdAreaProgramatica(e.target.value)} disabled={!IdAreaZona}>
              <option value="">Sin área programática</option>
              {areasProgramaticas.filter((item) => Number(item.IdAreaZona) === Number(IdAreaZona)).map((item) => <option key={item.IdAreaProgramatica} value={item.IdAreaProgramatica}>{item.Nombre}</option>)}
            </select></div></div>
          </div>

          {comorbilidadesSeleccionadas.length > 0 && (
            <p
              className="help"
              style={{
                marginTop: "6px",
                color: "#2563eb",
                fontWeight: "500",
              }}
            >
              Seleccionadas:{" "}
              {[...comorbilidadesDisponibles]
                .filter((c) =>
                  comorbilidadesSeleccionadas.includes(
                    c.IdComorbilidad.toString()
                  )
                )
                .map((c) => c.Nombre)
                .sort((a, b) => a.localeCompare(b))
                .join(", ")}
            </p>
          )}
        </div>
      )}

      {/* DIAGNÓSTICOS */}
      {diagnosticosDisponibles.length > 0 && (
        <div className="field mt-4">
          <label className="label">
            Diagnósticos (seleccione uno o varios)
          </label>
          <div
            className="box"
            style={{
              maxHeight: "200px",
              overflowY: "auto",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              padding: "0.75rem",
              backgroundColor: "#f9fafb",
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "6px 12px",
            }}
          >
            {[...diagnosticosDisponibles]
              .sort((a, b) => a.Nombre.localeCompare(b.Nombre))
              .map((diag) => (
                <label
                  key={diag.IdDiagnostico}
                  className="checkbox"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "4px 0",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                  }}
                >
                  <input
                    type="checkbox"
                    value={diag.IdDiagnostico}
                    checked={diagnosticosSeleccionados.includes(
                      diag.IdDiagnostico.toString()
                    )}
                    onChange={(e) => {
                      const id = e.target.value;
                      setDiagnosticosSeleccionados((prev) =>
                        e.target.checked
                          ? [...prev, id]
                          : prev.filter((d) => d !== id)
                      );
                    }}
                    style={{ marginRight: "8px" }}
                  />
                  {diag.Nombre}
                </label>
              ))}
          </div>

          {diagnosticosSeleccionados.length > 0 && (
            <p
              className="help"
              style={{
                marginTop: "6px",
                color: "#2563eb",
                fontWeight: "500",
              }}
            >
              Seleccionados:{" "}
              {[...diagnosticosDisponibles]
                .filter((d) =>
                  diagnosticosSeleccionados.includes(
                    d.IdDiagnostico.toString()
                  )
                )
                .map((d) => d.Nombre)
                .sort((a, b) => a.localeCompare(b))
                .join(", ")}
            </p>
          )}
        </div>
      )}

      {/* ESTILOS */}
      <style jsx>{`
        .cargar-contactos {
          max-width: 650px;
          margin: 30px auto;
          padding: 25px;
          background-color: #fafbfd;
          border-radius: 12px;
          box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
          font-family: "Segoe UI", sans-serif;
        }
        .field {
          margin-bottom: 15px;
        }
        .label {
          font-weight: 600;
          display: block;
          margin-bottom: 5px;
        }
        .required::after {
          content: " *";
          color: red;
        }
        .input {
          width: 100%;
          padding: 8px;
          border-radius: 8px;
          border: 1px solid #ccc;
          font-size: 14px;
        }
        .mensaje {
          margin-top: 10px;
          padding: 10px;
          border-radius: 10px;
          text-align: center;
          font-weight: 500;
          font-size: 14px;
        }
        .mensaje.bloqueo {
          border: 1px solid #e74c3c;
          color: #e74c3c;
          background: #fdecea;
        }
        .mensaje.informativo {
          border: 1px solid #27ae60;
          color: #27ae60;
          background: #eafaf1;
        }
      `}</style>
 

        {/* Sexo */}
        <div className="field">
          <label className="label required">Sexo</label>
          <div className="control">
            <div className="select is-fullwidth">
              <select value={Sexo} onChange={(e) => setSexo(e.target.value)} placeholder="Seleccionar" required>
                <option value="">Seleccionar</option>
                <option value={"Masculino"}>Masculino</option>
                <option value={"Femenino"}>Femenino</option>
              </select>
            </div>
          </div>
        </div>


        {/* Género */}
        <div className="field">
          <label className="label required">Género</label>
          <div className="control">
            <div className="select is-fullwidth">
              <select value={Genero} onChange={(e) => setGenero(e.target.value)} required>
                <option value="">Seleccione género</option>
                <option value="Desconocido">Desconocido</option>
                <option value="Mujer cis">Mujer cis</option>
                <option value="Mujer trans">Mujer trans</option>
                <option value="Varón cis">Varón cis</option>
                <option value="Varón trans">Varón trans</option>
                <option value="Otro">Otro</option>
              </select>
            </div>
          </div>
        </div>

        {/* Localidad/Dirección */}
        <div className="field">
          <label className="label required">Localidad / Dirección</label>
          <div className="control" style={{ display: "flex", gap: "8px" }}>
            <input
              type="text"
              className="input"
              value={direccion}
              placeholder="Seleccione en el mapa"
              readOnly
              required
              style={{ background: "#f3f4f6", cursor: "pointer" }}
              onClick={handleAbrirMapa}
            />
            <button type="button" className="button is-info" onClick={handleAbrirMapa}>
              Seleccionar en mapa
            </button>
          </div>
          {coordenadas && (
            <p className="help" style={{ color: "#2563eb" }}>
              Lat: {coordenadas.lat}, Lng: {coordenadas.lng}
            </p>
          )}
        </div>

        {/* Modal del mapa con Leaflet */}
        <Modal
          isOpen={modalMapaAbierto}
          onRequestClose={handleCerrarMapa}
          contentLabel="Seleccionar Localidad/Dirección"
          ariaHideApp={false}
          style={{
            overlay: { zIndex: 1000, background: "rgba(0,0,0,0.4)" },
            content: { maxWidth: 600, margin: "auto", borderRadius: 12 }
          }}
        >
          <h2>Seleccionar Localidad / Dirección</h2>
          {/* Buscador de dirección con autocompletado */}
          <div style={{ marginBottom: 18, position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <label className="label" style={{ fontSize: '15px', marginBottom: 6, color: '#2563eb', fontWeight: 600 }}>Buscar dirección</label>
            <input
              type="text"
              className="input"
              style={{ fontSize: '15px', padding: '8px 14px', height: 36, minHeight: 0, maxWidth: 400, border: '1.5px solid #2563eb', borderRadius: 8, boxShadow: '0 2px 8px #e0e7ff' }}
              value={direccion}
              onChange={e => {
                setDireccion(e.target.value);
                setUbicacionGeoLoc(null);
                buscarDireccion(e.target.value);
              }}
              placeholder="Escriba la dirección o selecciónela en el mapa"
              autoComplete="off"
            />
            {buscandoDireccion && (
              <div style={{ position: 'absolute', top: 48, left: 0, right: 0, background: '#fff', zIndex: 10, padding: 10, border: '1.5px solid #2563eb', borderRadius: 8, fontSize: 14, color: '#2563eb', boxShadow: '0 2px 8px #e0e7ff' }}>
                Buscando...
              </div>
            )}
            {sugerenciasDireccion.length > 0 && (
              <ul style={{ position: 'absolute', top: 48, left: 0, right: 0, background: '#fff', zIndex: 10, listStyle: 'none', margin: 0, padding: 0, border: '1.5px solid #2563eb', borderRadius: 8, maxHeight: 180, overflowY: 'auto', boxShadow: '0 2px 8px #e0e7ff' }}>
                {sugerenciasDireccion.map((s, idx) => (
                  <li
                    key={s.place_id}
                    style={{ padding: '10px 16px', cursor: 'pointer', fontSize: 14, borderBottom: idx !== sugerenciasDireccion.length - 1 ? '1px solid #e0e7ff' : 'none', transition: 'background 0.2s' }}
                    onClick={() => {
                      setDireccion(s.display_name);
                      setCoordenadas({ lat: parseFloat(s.lat), lng: parseFloat(s.lon) });
                      setUbicacionGeoLoc(s);
                      setSugerenciasDireccion([]);
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f0f9ff'}
                    onMouseLeave={e => e.currentTarget.style.background = '#fff'}
                  >
                    {s.display_name}
                  </li>
                ))}
              </ul>
            )}
          </div>
          {/* Mapa */}
          <div style={{ height: 350, borderRadius: 16, marginBottom: 18, boxShadow: '0 4px 16px #e0e7ff', border: '2px solid #2563eb' }}>
            <MapContainer
              center={coordenadas || [-34.6037, -58.3816]}
              zoom={15}
              style={{ height: "100%", width: "100%", borderRadius: 16 }}
            >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <LocationMarker />
            </MapContainer>
          </div>
          <div style={{ marginBottom: 12, color: '#2563eb', fontWeight: 500 }}>
            {coordenadas ? `Ubicación seleccionada: Lat ${coordenadas.lat.toFixed(5)}, Lng ${coordenadas.lng.toFixed(5)}` : 'Hacé click en el mapa para seleccionar una ubicación.'}
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 12 }}>
            <button className="button is-success" style={{ minWidth: 120, fontWeight: 600, fontSize: 15 }} onClick={handleSeleccionarDireccion} disabled={!coordenadas}>
              Usar esta ubicación
            </button>
            <button className="button" style={{ minWidth: 100, fontWeight: 500, fontSize: 15 }} onClick={handleCerrarMapa}>
              Cancelar
            </button>
          </div>
        </Modal>

        {/* Email */}
        <div className="field">
          <label className="label">Email</label>
          <div className="control">
            <input type="email" className="input" value={Email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" />
          </div>
        </div>
        {/* Teléfono */}
        <div className="field">
          <label className="label required">Teléfono</label>
          <div className="control">
            <input type="text" className="input" value={Telefono} onChange={(e) => setTelefono(e.target.value)} placeholder="Teléfono" required />
          </div>
        </div>

        <div className="field">
          <label className="label">Observaciones</label>
          <div className="control">
            <textarea className="textarea" value={Observaciones} onChange={(e) => setObservaciones(e.target.value)} placeholder="Observaciones clínicas" rows={3} />
          </div>
        </div>

        <div className="field">
          <label className="label">Fecha de apertura</label>
          <div className="control"><input type="date" className="input" value={FechaApertura} onChange={(e) => setFechaApertura(e.target.value)} disabled={desconoceFechaApertura} style={{ backgroundColor: desconoceFechaApertura ? "#e0e0e0" : "white" }} max={fechaActual} /><label className="checkbox ml-2"><input type="checkbox" checked={desconoceFechaApertura} onChange={(e) => { setDesconoceFechaApertura(e.target.checked); if (e.target.checked) setFechaApertura(""); }} /> Se desconoce la fecha</label></div>
        </div>
        <div className="field">
          <label className="label">Fecha de notificación</label>
          <div className="control"><input type="date" className="input" value={FechaNotificacion} onChange={(e) => { const valor = e.target.value; setFechaNotificacion(valor); setSemanaEpidemiologica(calcularSemanaEpidemiologica(valor)); }} disabled={desconoceFechaNotificacion} style={{ backgroundColor: desconoceFechaNotificacion ? "#e0e0e0" : "white" }} max={fechaActual} /><label className="checkbox ml-2"><input type="checkbox" checked={desconoceFechaNotificacion} onChange={(e) => { setDesconoceFechaNotificacion(e.target.checked); if (e.target.checked) { setFechaNotificacion(""); setSemanaEpidemiologica(""); } }} /> Se desconoce la fecha</label></div>
        </div>
        <div className="field">
          <label className="label">Semana epidemiológica</label>
          <div className="control"><input type="number" className="input" min="1" max="53" value={SemanaEpidemiologica} onChange={(e) => setSemanaEpidemiologica(e.target.value)} placeholder="1 a 53" /></div>
          <p className="help">Se calcula automáticamente desde la fecha de notificación y puede corregirse.</p>
        </div>
        <div className="field">
          <label className="label">Clasificación inicio tratamiento</label>
          <div className="control"><div className="select is-fullwidth"><select value={ClasificacionInicioTratamiento} onChange={(e) => setClasificacionInicioTratamiento(e.target.value)}><option value="">Sin asignar</option>{estadosTratamiento.filter((item) => !item.CampoAplicacion || item.CampoAplicacion === "CLASIFICACION_INICIO" || item.CampoAplicacion === "AMBOS").map((item) => <option key={item.IdEstadoTratamientoPorPatologia} value={item.Nombre}>{item.Nombre}</option>)}</select></div></div>
        </div>
        <div className="field">
          <label className="label">Resultado del tratamiento</label>
          <div className="control"><div className="select is-fullwidth"><select value={ResultadoTratamiento} onChange={(e) => setResultadoTratamiento(e.target.value)}><option value="">Sin asignar</option>{estadosTratamiento.filter((item) => !item.CampoAplicacion || item.CampoAplicacion === "RESULTADO" || item.CampoAplicacion === "AMBOS").map((item) => <option key={item.IdEstadoTratamientoPorPatologia} value={item.Nombre}>{item.Nombre}</option>)}</select></div></div>
        </div>

        <div className="field">
  <label className="label required">Seleccione la fecha de probable exposición</label>
  <div className="control">
    <input
      type="date"
      className="input"
      value={fechaExposicion}
      onChange={validarFechaExposicion}
      disabled={desconoceFechaExposicion}
      style={{ backgroundColor: desconoceFechaExposicion ? "#e0e0e0" : "white" }}
      max={fechaActual}
    />
    {errorFechaExposicion && (
      <p className="has-text-danger mt-1">{errorFechaExposicion}</p>
    )}
    <label className="checkbox ml-2">
      <input
        type="checkbox"
        checked={desconoceFechaExposicion}
        onChange={(e) => setDesconoceFechaExposicion(e.target.checked)}
      />{" "}
      Se desconoce la fecha
    </label>
  </div>
</div>




        {/* Fecha de síntomas */}
        <div className="field">
          <label className="label required">Seleccione la fecha de inicio de síntomas</label>
          <div className="control">
            <input type="date" className="input" value={fechaSintomas} onChange={validarFechaSintomas} disabled={desconoceFechaSintomas} style={{ backgroundColor: desconoceFechaSintomas ? "#e0e0e0" : "white" }} max={fechaActual} />
            {errorFechaSintomas && <p className="has-text-danger mt-1">{errorFechaSintomas}</p>}
            <label className="checkbox ml-2">
              <input type="checkbox" checked={desconoceFechaSintomas} onChange={(e) => setDesconoceFechaSintomas(e.target.checked)} /> Se desconoce la fecha
            </label>
          </div>
        </div>

        {/* Fecha de consulta */}
        <div className="field">
          <label className="label required">Seleccione la fecha de primera consulta</label>
          <div className="control">
            <input type="date" className="input" value={fechaConsulta} onChange={validarFechaConsulta} disabled={desconoceFechaConsulta} style={{ backgroundColor: desconoceFechaConsulta ? "#e0e0e0" : "white" }} max={fechaActual} />
            {errorFechaConsulta && <p className="has-text-danger mt-1">{errorFechaConsulta}</p>}
            <label className="checkbox ml-2">
              <input type="checkbox" checked={desconoceFechaConsulta} onChange={(e) => setDesconoceFechaConsulta(e.target.checked)} /> Se desconoce la fecha
            </label>
          </div>
        </div>

        <div className="field">
          <label className="label">Fecha inicio de tratamiento</label>
          <div className="control"><input type="date" className="input" value={FechaInicioTratamiento} onChange={(e) => { setFechaInicioTratamiento(e.target.value); if (FechaFinTratamiento && FechaFinTratamiento < e.target.value) setFechaFinTratamiento(""); }} disabled={desconoceFechaInicioTratamiento} style={{ backgroundColor: desconoceFechaInicioTratamiento ? "#e0e0e0" : "white" }} max={fechaActual} /><label className="checkbox ml-2"><input type="checkbox" checked={desconoceFechaInicioTratamiento} onChange={(e) => { setDesconoceFechaInicioTratamiento(e.target.checked); if (e.target.checked) setFechaInicioTratamiento(""); }} /> Se desconoce la fecha</label></div>
        </div>
        <div className="field">
          <label className="label">Fecha fin de tratamiento</label>
          <div className="control"><input type="date" className="input" value={FechaFinTratamiento} onChange={(e) => setFechaFinTratamiento(e.target.value)} disabled={desconoceFechaFinTratamiento} style={{ backgroundColor: desconoceFechaFinTratamiento ? "#e0e0e0" : "white" }} min={FechaInicioTratamiento || undefined} max={fechaActual} /><label className="checkbox ml-2"><input type="checkbox" checked={desconoceFechaFinTratamiento} onChange={(e) => { setDesconoceFechaFinTratamiento(e.target.checked); if (e.target.checked) setFechaFinTratamiento(""); }} /> Se desconoce la fecha</label></div>
        </div>
        {/* Botones */}
        <div className="level">
          <div className="level-left">
            <FontAwesomeIcon icon={faSquareCaretLeft} size="2xl" style={{ color: "#3488CE", cursor: "pointer" }} onClick={handleGoBack} />
          </div>
          <div className="field level-right">
            <button className="button is-success" onClick={createPersona}>
              Guardar <FontAwesomeIcon icon={faCheck} size="2xl" style={{ color: "white" }} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPersona;

